import { render } from "./Hall2En.vue?vue&type=template&id=d7867e5a"
import script from "./Hall2En.vue?vue&type=script&lang=js"
export * from "./Hall2En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__